import React from 'react';
import cx from 'classnames';
import LoginLogout from './LoginLogout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
const CONTACT_US = 'https://www.gptx.org/Contact-Us';
const YOUTUBE = 'https://www.youtube.com/user/cityofgptx';
const FACEBOOK = 'https://www.facebook.com/cityofgptx/';
function Footer({ className }) {
    return (<footer className={cx('footer', className)} data-testid="footer">
      <div className="footer-wrapper">
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} Comcate, Inc.
        </p>
        <nav className="footer-nav" aria-label="Footer navigation">
          {CONTACT_US && (<a className="footer-link" target="_blank" href={CONTACT_US}>
              Contact Us
            </a>)}
          <a className="footer-link" target="_blank" href={YOUTUBE} aria-label="Visit our YouTube channel">
            <FontAwesomeIcon icon={faYoutube}/>
          </a>
          <a className="footer-link" target="_blank" href={FACEBOOK} aria-label="Visit our Facebook page">
            <FontAwesomeIcon icon={faFacebookF}/>
          </a>
          <LoginLogout className="footer-link"/>
        </nav>
      </div>
    </footer>);
}
export default Footer;
